// Rekit uses a new approach to organizing actions and reducers. That is
// putting related actions and reducers in one file. See more at:
// https://medium.com/@nate_wang/a-new-approach-for-managing-redux-actions-91c26ce8b5da

import {
  SIMULADOR_FINANCIERO_SET_DEFAULT_ALTA_LINEA,
  veicleTypeDefault,
} from './constants';

export function setDefaultAltaLinea() {
  return {
    type: SIMULADOR_FINANCIERO_SET_DEFAULT_ALTA_LINEA,
  };
}

export function reducer(state, action) {
  if (action.type === SIMULADOR_FINANCIERO_SET_DEFAULT_ALTA_LINEA) {
      let altaLineaSettings = {
        pasos: [
          {
            id: 1,
            name: 'Datos financieros',
            active: true,
            selected: true
          },
          {
            id: 2,
            name: 'Asignación de líneas',
            active: false,
            selected: false
          }
        ],
        pasoSelected: {
          id: 1,
          name: 'Datos financieros',
          active: true,
          selected: true
        }
      };
      let altaNuevaLinea = {
        id: null,
        datosFinancieros: {
          entidadOtorgante: {},
          tipoCredito: {},
          lineaCreditoBancaria: '',
          lineaComercial: '',
          tipoTasa: '',
          cuotas: [],
          cuotasPreviousValues: [],
          requisitos: '',
          fechaVigenciaIni: null,
          fechaVigenciaFin: null,
          promocionClienteBanco: true,
          beneficio: '',
          exceedFinanceLimit: false,
        },
        asignacionLineas: {
          tipoVehiculo: true,
          antiguedad: {},
          marca: { label: 'Todas', value: null, id: 'marca' },
          modelo: { label: 'Todos', value: null, id: 'modelo' },
          version: { label: 'Todas', value: null, id: 'version' },
          lineas: []
        }
      }
      return {
        ...state,
        veicleType: veicleTypeDefault,
        altaNuevaLinea: altaNuevaLinea,
        altaLineaSettings: altaLineaSettings
      };
  }
  else {
      return state;
  }
}
